import {LitElement, html, unsafeCSS} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import quote from "./bg-quote.scss?inline"

export interface BgQuoteInterface {
  image: string, 
  name: string, 
  title: string, 
}

/**
 * An example element.
 *
 * @slot - This element has a slot
 * @csspart button - The button
 */

@customElement('bg-quote')
export class BgQuote extends LitElement {

  constructor(args:BgQuoteInterface) {
    super();
    if(!args) {
      return
    };
    this.title = args.title;
  }

  @property()
  docsHint = '';
  
  @property({ type: String })
  src = "";

  @property({ type: String })
  name = "";
  
  @property({ type: String })
  color = "";

  @property({ type: String })
  title = "";

  render() {
    return html`
    <div class="quote-container" style="--color:${this.color}">
        <div class="quote-mark">“</div>
        <slot></slot>
        <div class="quote-mark-end">“</div>
        <div class="quote-source">
          <slot name="quote-source"></slot>
        </div>
    </div>
    `
  }
  
  static styles = [
    unsafeCSS(quote)
  ]
}

declare global {
  interface HTMLElementTagNameMap {
    'bg-quote': BgQuote
  }
}
